import devapis from "./dev.endpoints";
import stagingapis from "./staging.endpoints";
import prodapis from "./prod.endpoints";
const localtodev = "http://localhost:3000,http://localhost:3001,";
const localtostage = "";
const localtoprod = "";

export const endpoints = {
  dev: {
    base: `${localtodev}https://devlogin.shatabdiloans.com/open/login`,
    baseFE_URL: `https://devlogin.shatabdiloans.com/open/login`,
    api_base: "https://devapi.shatabdiloans.com",
    static_token: "",
    ...devapis,
    "open/login": {
      base: `${localtodev}https://devlogin.shatabdiloans.com/open/login`,
      api_base: "https://devapi.shatabdiloans.com",
      ...devapis,
    },
    "open/customer/login": {
      base: `${localtodev}https://devlogin.shatabdiloans.com/open/customer/login`,
      api_base: "https://devapi.shatabdiloans.com",
      ...devapis,
    },
  },
  staging: {
    base: `${localtostage}https://devlogin.shatabdiloans.com/open/login`,
    baseFE_URL: `https://devlogin.shatabdiloans.com/open/login`,
    api_base: "https://devapi.shatabdiloans.com",
    static_token: "",
    ...stagingapis,

    "open/login": {
      base: `${localtostage}https://devlogin.shatabdiloans.com/open/login`,
      api_base: "https://devapi.shatabdiloans.com",
      ...stagingapis,
    },
  },
  production: {
    base: `${localtoprod}https://login.shatabdiloans.com/open/login`,
    baseFE_URL: `https://login.shatabdiloans.com/open/login`,
    api_base: "https://api.shatabdiloans.com",
    static_token: "",
    ...prodapis,

    "open/login": {
      base: "https://login.shatabdiloans.com/open/login",
      api_base: "https://api.shatabdiloans.com",
      ...prodapis,
    },
    "open/customer/login": {
      base: "https://login.shatabdiloans.com/open/customer/login",
      api_base: "https://api.shatabdiloans.com",
      ...prodapis,
    },
  },
};
console.log(
  Object.entries(endpoints)
    .map(([key, val]) => ({ ...val, name: key }))
    .find((obj) =>
      (obj?.base?.split(",") || []).includes(window?.location?.origin)
    )
);
export default endpoints;
